import { render, staticRenderFns } from "./ARiskWidget.vue?vue&type=template&id=84f4c574&scoped=true&"
import script from "./ARiskWidget.vue?vue&type=script&lang=ts&"
export * from "./ARiskWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ARiskWidget.vue?vue&type=style&index=0&id=84f4c574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f4c574",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSlider,VSpacer,VTextField,VTextarea})
